import { render, staticRenderFns } from "./LayoutsAutobus.vue?vue&type=template&id=183ed476&"
import script from "./LayoutsAutobus.vue?vue&type=script&lang=js&"
export * from "./LayoutsAutobus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports